import React from 'react';
import { PropInfo, CodeExample, TagProps } from '@cimpress/react-components';
import TagCode from '!raw-loader!./tag.jsx';
import TagDemo from './tag.jsx';
import ComponentDoc from '../../shared/TabbedComponentDoc';

const TagDocs = () => {
  const propInfos: PropInfo<TagProps>[] = [
    {
      name: 'removable',
      type: 'boolean',
      default: 'false',
      description:
        "Determines whether to show an 'x' at the right hand side of the component to indicate the tag can be removed.",
    },
    {
      name: 'onRemoveClick',
      type: 'function',
      default: '',
      description: 'Function to be called when the x to remove the tag is clicked',
    },
    {
      name: 'label',
      type: 'node',
      default: '',
      description: 'Label to render within the tag. If not provided, value will be shown.',
    },
    {
      name: 'value',
      type: 'node',
      default: '',
      description: 'Value represented by the tag.',
    },
    {
      name: 'size',
      type: 'string',
      description: (
        <div>
          One of the following:
          <ul>
            <li>sm</li>
            <li>lg</li>
          </ul>
          If not defined, will default to a medium size.
        </div>
      ),
      default: '',
    },
  ];

  return (
    <ComponentDoc name="Tag" propInfos={propInfos}>
      <TagDemo />
      <CodeExample code={TagCode} />
    </ComponentDoc>
  );
};

export default TagDocs;
